import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function contactRepresentative(contactRepForm) {
    const request = axios.post(urls.CONTACT_REP_URL, contactRepForm, {
    headers: {
      "Content-Type": "application/json"
    }
  });
    return { type: ActionTypes.CONTACT_REP, payload: request };
}

//export function shareByEmail(shareCartParams) {
//    const request = axios.post(urls.SHARE_BY_EMAIL_URL, shareCartParams);
//    return { type: ActionTypes.SHARE_BY_EMAIL, payload: request };
//}

